import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import LoginSSO from './views/LoginSSO.vue'
import LoginSSO2 from './views/LoginSSO2.vue'
import Announcement from './views/Announcement.vue'
import Preferences from './views/Preferences.vue'
import ForcePasswordUpdate from './views/ForcePasswordUpdate.vue'
import Users from './views/admin/Users.vue'
import User from './views/admin/User.vue'
import UserNotFound from './views/UserNotFound'
import NotFound from './views/NotFound'
import store from './store'
import { getCompanyCode, getLoginId } from './util/token'
import accountService from '@/services/account.service'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: 'ログイン' },
    },
    {
      path: '/login/sso',
      name: 'login_sso',
      component: LoginSSO,
      meta: { title: 'ログイン' },
    },
    {
      path: '/login/sso2',
      name: 'login_sso2',
      component: LoginSSO2,
      meta: { title: 'ログイン' },
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: 'ホーム', requiresAuth: true },
    },
    {
      path: '/passwordupdate',
      name: 'passwordupdate',
      component: ForcePasswordUpdate,
      meta: { title: 'パスワード変更', requiresAuth: true },
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: Announcement,
      meta: { page: { title: 'お知らせ', requiresAuth: true } },
    },
    {
      path: '/preferences',
      name: 'preferences',
      component: Preferences,
      meta: { title: '個人設定', requiresAuth: true },
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: { title: 'ユーザーリスト', requiresAuth: true, admin: true },
    },
    {
      path: '/user/:loginId',
      name: 'user_edit',
      component: User,
      meta: { title: 'ユーザー更新', requiresAuth: true, admin: true },
    },
    {
      path: '/user',
      name: 'user_registration',
      component: User,
      meta: { title: 'ユーザー登録', requiresAuth: true, admin: true },
    },
    {
      path: '/usernotfound',
      name: 'user_not_found',
      component: UserNotFound,
      meta: { requiresAuth: true, admin: true },
    },
    {
      path: '/404',
      name: 'not_found',
      component: NotFound,
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = `BiZoo | ${to.meta.title}`
    store.commit('setCurrentPage', { title: to.meta.title })
  }

  const requiresAuth = to.meta && to.meta.requiresAuth
  const mustBeAdmin = to.meta && to.meta.admin
  const user = store.state.user

  // 直接特定のエンドポイントにアクセスした場合などはStoreの内容がクリアされてしまっているので、
  // 最後にトークンを取得したログインIDからアカウント情報を取得して復元する。
  // 非同期処理が絡むので、Storeの初期化時には出来ない気がするのでここで行う。
  //
  // アプリ内の画面遷移の場合、storeにログイン情報がもう入っているので、"復元"は不要。
  // => StoreのログインIDが入っているか？で判断する。
  const loginId = getLoginId()
  if (!user.loginId && loginId) {
    try {
      const companyCode = getCompanyCode()
      const account = await accountService.getAccount(companyCode, loginId)
      store.commit('setUser', {
        userId: account.userId,
        companyCode,
        loginId,
        isAdmin: account.roles.includes('admin'),
        requiresPasswordChange: !!account.password,
      })
    } catch (e) {
      // アカウント取得時にエラー（トークンの再発行ができない場合を含む）があっても続行し、
      // ログイン済ではないものとして後続の処理を行う。
    }
  }

  // 認証、認可のチェック
  if (requiresAuth) {
    if (!user || !user.userId) {
      next({ path: '/login', query: { redirect: to.fullPath } })
      return
    }
  }
  if (mustBeAdmin) {
    if (!user || !user.isAdmin) {
      next({ path: '/' })
      return
    }
  }

  // ログインはしているが、パスワード変更が済んでいない可能性がある。
  // その場合、一応トークンはもらえてログインできるが、使える機能は制限する必要がある。
  if (
    to.name !== 'passwordupdate' &&
    requiresAuth &&
    user.requiresPasswordChange
  ) {
    next('/passwordupdate')
    return
  }

  next()
})

export default router
